export default {
  login: {
    imageTitle: 'Profitez, on s\'occupe de votre déménagement',
    imageSubtitle: 'Nous vous accompagnons gratuitement dans votre sélection de déménageurs et vos transferts de contrats.',
  },
  menus: {
    home: 'Accueil',
    profile: 'Profil',
    comparator: 'Comparatif',
    procedures: 'Démarches',
    declaration: 'Déclaration de valeur',
    contact: 'Contact',
    details: 'Détails',
    quote: 'Mon devis',
    paiement: 'Paiement',
    meeting: 'Rendez-vous',
    addresses: 'Mes adresses',
    inventory: 'Inventaire',
    invoices: 'Factures',
    perks: 'Avantages Nextories',
    moving: 'Mon déménagement',
  },
  navbar: {
    title: 'Un déménagement, de belles histoires',
    account: 'Mon compte',
    profile: 'Profil',
    signOut: 'Déconnexion',
    fileNumber: 'Numéro de dossier',
  },
};
